/* Copyright (c) 2017 Backpack Health LLC */

import React, { FC }  from 'react'
import { FormattedMessage } from 'react-intl';

import { ExternalLink } from 'components/common/TextLink';

interface PolicyLinkProps {
  phraseUrl: any;
  phraseText: any;
  className: string;
}
const PolicyLink: FC<PolicyLinkProps> = (props) => (
  <FormattedMessage {...props.phraseUrl}>
    {
      (url: string) => (
        <ExternalLink className={props.className} href={url}>
          <FormattedMessage {...props.phraseText} />
        </ExternalLink>
      )
    }
  </FormattedMessage>
)

interface LinkStyles {
  className: string;
}
export const PrivacyLink: FC<LinkStyles> = (props) => (
  <PolicyLink
    className={props.className}
    phraseUrl={{
      id: 'legal.privacyPolicy.URL',
    }}
    phraseText={{
      id: 'groupSetup.privacy.link.text',
    }}
  />
);

export const TermsLink: FC<LinkStyles> = (props) => (
  <PolicyLink
    className={props.className}
    phraseUrl={{
      id: 'legal.termsOfService.URL',
    }}
    phraseText={{
      id: 'groupSetup.terms.link.text',
    }}
  />
);

export const AcknowledgementsLink: FC<LinkStyles> = (props) => (
  <PolicyLink
    className={props.className}
    phraseUrl={{
      id: 'legal.acknowledgements.URL',
    }}
    phraseText={{
      id: 'legal.acknowledgements.URL.name',
    }}
  />
);

export const CookiePolicyLink: FC<LinkStyles> = (props) => (
  <PolicyLink
    className={props.className}
    phraseUrl={{
      id: 'legal.cookiePolicy.URL',
    }}
    phraseText={{
      id: 'groupSetup.cookiePolicy.link.text',
    }}
  />
);
